export async function getFirebaseIdTokenFromRefreshToken(refreshToken, apiKey) {
  if (!refreshToken) throw new Error("No refresh token provided");
  if (!apiKey) throw new Error("No Firebase API key provided");

  const url = `https://securetoken.googleapis.com/v1/token?key=${apiKey}`;
  const params = new URLSearchParams();
  params.append('grant_type', 'refresh_token');
  params.append('refresh_token', refreshToken);

  const res = await fetch(url, {
    method: 'POST',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    body: params
  });

  const data = await res.json();

  if (!res.ok) {
    // Log the full error response for debugging
    console.error('Firebase refresh error:', data);
    throw new Error(
      data.error && data.error.message
        ? `Failed to refresh Firebase token: ${data.error.message}`
        : 'Failed to refresh Firebase token'
    );
  }

  return data;
}